import { all, takeLatest, put, race, take } from 'redux-saga/effects'
import { SUCCESS, FAILED } from 'crom-api-constants'
import _ from 'lodash'

import {
    GET_FAVOURITES,
    ADD_TO_FAVOURITES,
    REMOVE_FROM_FAVOURITES,
    LOAD_FAVOURITES_REQUEST,
    ADD_TO_FAVOURITES_REQUEST,
    REMOVE_FROM_FAVOURITES_REQUEST,
    LOCALE_PREFIX,
} from './constants'

import { error } from '../../../../../../../../services/toastr'

import { changeEntityStackTab } from '../../../../actions'

import { getFavouritesRequest, addToFavouritesRequest, removeFromFavouritesRequest, favouritesLoaded } from './actions'

const LOAD_FAVOURITES_REQUEST_SUCCESS = `${LOAD_FAVOURITES_REQUEST}_${SUCCESS}`
const LOAD_FAVOURITES_REQUEST_FAILED = `${LOAD_FAVOURITES_REQUEST}_${FAILED}`

const ADD_TO_FAVOURITES_REQUEST_SUCCESS = `${ADD_TO_FAVOURITES_REQUEST}_${SUCCESS}`
const ADD_TO_FAVOURITES_REQUEST_FAILED = `${ADD_TO_FAVOURITES_REQUEST}_${FAILED}`

const REMOVE_FROM_FAVOURITES_REQUEST_SUCCESS = `${REMOVE_FROM_FAVOURITES_REQUEST}_${SUCCESS}`
const REMOVE_FROM_FAVOURITES_REQUEST_FAILED = `${REMOVE_FROM_FAVOURITES_REQUEST}_${FAILED}`

function* loadFavouritesCallSaga() {
    yield put(getFavouritesRequest())

    const result = yield race({
        success: take(LOAD_FAVOURITES_REQUEST_SUCCESS),
        failed: take(LOAD_FAVOURITES_REQUEST_FAILED),
    })

    if (!result.failed) {
        const data = _.get(result, 'success.payload.response.body.data', [])

        yield put(favouritesLoaded(data))
    } else {
        error({
            id: `${LOCALE_PREFIX}.getError`,
        })
    }

    return null
}

function* addToFavouritesCallSaga(action) {
    const entId = parseInt(_.get(action, 'data.entId', null), 10)

    if (!entId) return null

    yield put(addToFavouritesRequest(entId))

    const result = yield race({
        success: take(ADD_TO_FAVOURITES_REQUEST_SUCCESS),
        failed: take(ADD_TO_FAVOURITES_REQUEST_FAILED),
    })

    if (!result.failed) {
        const data = _.get(result, 'success.payload.response.body.data', [])

        yield put(favouritesLoaded(data))
        yield put(changeEntityStackTab('favourites'))
    } else {
        error({
            id: `${LOCALE_PREFIX}.addError`,
        })
    }

    return null
}

function* removeFromFavouritesCallSaga(action) {
    const entId = _.get(action, 'data.entId', null)

    if (!entId) return null

    yield put(removeFromFavouritesRequest(entId))

    const result = yield race({
        success: take(REMOVE_FROM_FAVOURITES_REQUEST_SUCCESS),
        failed: take(REMOVE_FROM_FAVOURITES_REQUEST_FAILED),
    })

    if (!result.failed) {
        const data = _.get(result, 'success.payload.response.body.data', [])

        yield put(favouritesLoaded(data))
        yield put(changeEntityStackTab('favourites'))
    } else {
        error({
            id: `${LOCALE_PREFIX}.removeError`,
        })
    }

    return null
}

export default function* favouritesSaga() {
    yield all([
        takeLatest(GET_FAVOURITES, loadFavouritesCallSaga),
        takeLatest(ADD_TO_FAVOURITES, addToFavouritesCallSaga),
        takeLatest(REMOVE_FROM_FAVOURITES, removeFromFavouritesCallSaga),
    ])
}
